<template>
  <v-chart :options="chartOptions" autoresize class="patient-type-chart" />
</template>

<script>
import ECharts from "vue-echarts"; // Import ECharts wrapper for Vue
import "echarts/lib/chart/pie"; // Ensure pie chart module is included
import "echarts/lib/component/legend"; // Import legend component
import "echarts/lib/component/tooltip"; // Import tooltip for mouseover info

export default {
  components: {
    "v-chart": ECharts,
  },
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    chartOptions() {
      // Initialize patient type count map
      let patientTypeCount = {};

      // Aggregate data from chartData
      this.chartData.forEach((item) => {
        if (item.patientType) {
          if (!patientTypeCount[item.patientType]) {
            patientTypeCount[item.patientType] = 0;
          }
          patientTypeCount[item.patientType]++;
        }
      });

      // Prepare the data for the pie chart
      const pieData = Object.keys(patientTypeCount).map((key) => ({
        value: patientTypeCount[key],
        name: key,
      }));

      return {
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            return `${params.seriesName} <br/>${params.name}: ${
              params.value
            } (${params.percent.toFixed(1)}%)`;
          },
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "Patient Type",
            type: "pie",
            radius: "48%",
            center: ["50%", "60%"], // Adjust center to make room for top legend
            data: pieData,
            label: {
              show: true,
              position: "outside", // Position the labels inside the pie slices
              formatter: "{b}: {c}", // b is the name, c is the value, d is the percentage
              fontSize: 12,
              color: "auto", // White color for better visibility against colored backgrounds
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.patient-type-chart {
  width: 100%;
}
</style>
